export const USER_INIT_STATE = {
  token: localStorage.getItem("token"),
  user: null,
  ioSocket: null,
  loading: false,
  error: "",
};
